import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Tabs, WhiteSpace, Toast, List } from "antd-mobile-v2";
import "./index.less";
import { edipData } from "./const";
import { get, headerGet, post, postRaw } from "../../api/service/services";
import allUrl from "../../api/allUrl";
import tool from "../../api/tool";
import sectionValue from "../../api/service/secsstion";
const tabs = [{ title: "投诉查询" }, { title: "建议查询" }];
const Item = List.Item;
const Brief = Item.Brief;
export default class QueryCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      complatListData: [],
      prosalListData: [],
    };
  }
  componentDidMount() {
    this.getPlaintData({ current: 1 });
    this.getprosalListData({ current: 1 });
  }
  // 获取建议征集列表数据
  getprosalListData = (data) => {
    postRaw(
      allUrl.register.getplaitData,
      {
        ...data,
        size: 200,
        applyType: "04",
        applyUserCode: sectionValue.get("acount")
          ? sectionValue.get("acount")
          : "",
        createDept: sectionValue.get("qiOrgCode"),
      },
      {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    ).then((res) => {
      if (res.success === true && res.code == 200) {
        let newData = res.data.records;
        this.setState({ prosalListData: newData });
      }
    });
  };
  // 获取投诉详情列表数据
  getPlaintData = (data) => {
    postRaw(
      allUrl.register.getplaitData,
      {
        ...data,
        size: 100,
        approvalStatus: "02",
        applyUserCode: sectionValue.get("acount")
          ? sectionValue.get("acount")
          : "",
        createDept: sectionValue.get("qiOrgCode"),
      },
      {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    )
      .then((res) => {
        if (res.success === true && res.code == 200) {
          let newData = res.data.records;
          this.setState({ complatListData: newData });
        } else {
          Toast.fail(res.msg, 1);
        }
      })
      .catch((error) => {
        Toast.fail("数据获取失败", 1);
      });
  };
  applyType = (text) => {
    let txt = "";
    if (text === "01") txt = "反映某事";
    if (text === "02") txt = "不同意某处理决定";
    if (text === "03") txt = "反映某人或某单位违法违纪问题";
    return txt;
  };

  render() {
    const { complatListData, prosalListData } = this.state;
    return (
      <div className="query-wrapper">
        <Tabs tabs={tabs} initialPage={0} animated={false} useOnPan={false}>
          <div
            style={{
              backgroundColor: "#fff",
            }}
          >
            <List className="my-list">
              {complatListData.length > 0 ? (
                complatListData.map((item, index) => {
                  return (
                    <Item
                      key={index}
                      arrow="horizontal"
                      multipleLine
                      onClick={() => {
                        this.props.history.push({
                          pathname: "/detialCompt",
                          state: {
                            detailCompt: item.id,
                          },
                        });
                      }}
                      platform="android"
                    >
                      {item.complaintTypeVal}&nbsp;&nbsp;
                      {item.createTime.split(" ")[0]}-{" "}
                      {item.book && item.book ? "已答复" : "办理中"}
                      <Brief>
                        {this.applyType(item.applyType)} {item.mainAppeal}
                      </Brief>
                    </Item>
                  );
                })
              ) : (
                <div className="empty-cont">暂无数据</div>
              )}
            </List>
          </div>
          <div
            style={{
              backgroundColor: "#fff",
            }}
          >
            <List className="my-list">
              {prosalListData.length > 0 ?
                prosalListData.map((item, index) => {
                  return (
                    <Item
                      key={index}
                      arrow="horizontal"
                      multipleLine
                      onClick={() => {
                        this.props.history.push({
                          pathname: "/solicitation",
                          state: {
                            detailCompt: item.id,
                          },
                        });
                      }}
                      platform="android"
                    >
                      {item.createTime.split(" ")[0]}-
                      {item.complaintParentOrgName}
                      <Brief>{item.mainAppeal}</Brief>
                    </Item>
                  );
                }) : <div className="empty-cont">暂无数据</div>
              }
            </List>
          </div>
        </Tabs>
      </div>
    );
  }
}
